export default "__VITE_ASSET__C1qG4nK8__"